import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import ReleaseInfoCard from '../../components/cards/v2/release-info.card';
import ReleasesContainer from '../../components/containers/releases.container';
import Header from '../../components/header/default.header';
import InfoLayout from '../../components/layouts/info.layout';
import MainLayout from '../../components/layouts/v2/main.layout';
import AlternativeNavigation from '../../components/navigation/alternative.navigation';
import HTab from '../../components/navigation/tabs/htab';
import { RELEASES_TAB_OPTIONS } from '../../components/navigation/tabs/tab-options';
import { useInfoControl } from '../../hooks/useInfoControl';
import { genres } from '../../test.data';
import { ReleaseItem } from '../../types/release.type';

export default function Releases() {
  const { genre } = useParams();

  const [genreFound, setGenreFound] = useState(false);

  const [showInfo, current, trigger, reset] = useInfoControl<ReleaseItem>();

  const [currentTab, setCurrentTab] = useState(RELEASES_TAB_OPTIONS.THIS_WEEK);

  const CONTENT_COMPONENT_MAP = {
    [RELEASES_TAB_OPTIONS.ALL]: () => (
      <ReleasesContainer
        trigger={trigger}
        params={{ genre: genre || '' }}
        query={genreFound ? ['ALL'] : []}
      />
    ),
    [RELEASES_TAB_OPTIONS.COMING_SOON]: () => (
      <ReleasesContainer
        trigger={trigger}
        params={{ genre: genre || '' }}
        query={genreFound ? ['COMING_SOON'] : []}
      />
    ),
    [RELEASES_TAB_OPTIONS.THIS_WEEK]: () => (
      <ReleasesContainer
        trigger={trigger}
        params={{ genre: genre || '' }}
        query={genreFound ? ['THIS_WEEK'] : []}
      />
    ),
    [RELEASES_TAB_OPTIONS.THIS_MONTH]: () => (
      <ReleasesContainer
        trigger={trigger}
        params={{ genre: genre || '' }}
        query={genreFound ? ['THIS_MONTH'] : []}
      />
    ),
  };

  useEffect(() => {
    if (genre) {
      const genreExists = genres.map(({ title }) => title).includes(genre);
      setGenreFound(genreExists);
    }
  }, [setGenreFound, genre]);

  return (
    <MainLayout title="Releases" layout="alt">
      <MainLayout.Header>
        <Header />
      </MainLayout.Header>
      <MainLayout.Content>
        <MainLayout.Navigation>
          <AlternativeNavigation />
        </MainLayout.Navigation>
        <MainLayout.Main>
          <InfoLayout close={reset} showInfo={showInfo}>
            <InfoLayout.Content>
              <HTab
                current={currentTab}
                set={setCurrentTab}
                tabOptions={RELEASES_TAB_OPTIONS}
                tabContent={CONTENT_COMPONENT_MAP}
                tabControlClassName="mobile:py-4 tablet-lg:pb-5 mobile:px-5 tablet-lg:px-[40px] border-b border-dark-gray"
              />
            </InfoLayout.Content>
            <InfoLayout.Aside>
              {current && (
                <ReleaseInfoCard releaseId={current.id} close={reset} />
              )}
            </InfoLayout.Aside>
          </InfoLayout>
        </MainLayout.Main>
      </MainLayout.Content>
    </MainLayout>
  );
}
